import { Star } from "lucide-react";

const items = [
    "The Best Solution",
    "Growth · Content · Paid",
    "Built To Ship",
    "Data Meets Story",
    "The Best Solution",
    "Growth · Content · Paid",
    "Built To Ship",
    "Data Meets Story",
];

export default function DigtekStarMarquee() {
    return (
        <section
            data-testid="digtek-star-marquee"
            className="digtek-star-marquee"
        >
            <div className="digtek-star-marquee-track">
                {items.concat(items).map((label, i) => (
                    <span key={i} className="inline-flex items-center gap-11">
                        <span className="star">
                            <Star className="w-6 h-6 fill-digtek-purple" />
                        </span>
                        <span>{label}</span>
                    </span>
                ))}
            </div>
        </section>
    );
}
